<div>
  <h2 mat-dialog-title *ngIf="!!data.headerText">{{data?.headerText}}</h2>
  <mat-dialog-content>
    <h4>{{data?.confirmationPromptText}}</h4>
  </mat-dialog-content>
  <mat-dialog-actions class="column-grid justify-content-end">
    <button
      *ngIf="data?.showCancelButton"
      mat-button
      type="button"
      (click)="cancel.emit()"
      mat-dialog-close>
      {{data?.cancelButtonText || 'Cancel'}}
    </button>
    <button
      mat-flat-button
      type="button"
      color="primary"
      (click)="confirm.emit()">
      {{data?.confirmButtonText || 'Confirm'}}
    </button>
  </mat-dialog-actions>
</div>
